export default class ModelMeta {
    created;
    updated = null;
    deleted = null;
}
//# sourceMappingURL=ModelMeta.js.map